import React from 'react';
import PropTypes from 'prop-types';
import { CSSTransition } from 'react-transition-group';

import { Icon } from '../../ui/icon';

import { getIndex } from './utils';

// styles
import css from './lightboxGallery.sss';

// images
import BackIconSvg from './images/back.icon.svg';
import NextIconSvg from './images/next.icon.svg';
import PreviewIconSvg from './images/preview.icon.svg';


export class LightboxGallery extends React.Component {
    state = {
        viewIndex: this.props.viewIndex || 0,
        preventDefault: false,
        swipeX: 0,
        swiping: false,
    };

    componentDidUpdate(prevProps) {
        if (this.props.viewIndex !== prevProps.viewIndex) {
            this.onGetStartIndex();
        }
    }

    onGetStartIndex = () => {
        this.setState({
            viewIndex: this.props.viewIndex,
        });
    }

    onChangeItem(index) {
        const { images } = this.props;

        if (index < 0) {
            index = (images.length - 1);
        } else if (index > (images.length - 1)) {
            index = 0;
        }

        this.setState({
            viewIndex: index,
            preventDefault: true,
        });
        this.preventDefaultClear();
    }


    preventDefaultClear() {
        setTimeout(() => {
            this.setState({
                preventDefault: false,
            });
        }, this.props.duration);
    }

    handleTouchStart = (e) => {
        const touch = e.touches[0];
        this.setState({
            swipeX: touch.clientX
        });
    }

    handleTouchMove = (e) => {
        if (e.changedTouches && e.changedTouches.length) {
            this.setState({
                swiping: true
            });
        }
    }

    handleTouchEnd = (e) => {
        const swipeDistance = this.props.swipeDistance;
        const { swipeX, viewIndex } = this.state;
        const touch = e.changedTouches[0];
        const moveX = touch.clientX - swipeX;
        const absMoveX = Math.abs(moveX);
        const nextIndex = moveX > 0 ? viewIndex - 1 : viewIndex + 1;

        if (this.state.swiping && absMoveX > swipeDistance) {
            this.onChangeItem(nextIndex);
        }
        this.setState({
            swipeX: 0,
            swiping: false
        });
    }


    renderItem(item, index) {
        const { images, duration, transitionFunction } = this.props;
        const { viewIndex } = this.state;

        const currentItem = getIndex(viewIndex, images.length);

        let translateX = index - viewIndex > 0 ? 150 : -150; // all next must be at the end, all prev - at the start
        if ((viewIndex === images.length - 1) && index === 0) { // if view last, first must be at the end
            translateX = 150;
        }
        if ((viewIndex === 0) && (index === images.length - 1)) { // if view first, last must be at the start
            translateX = -150;
        }
        if (index === viewIndex) translateX = 0; // current item

        return (
            <li
                key={index}
                className={index === currentItem ? css.itemCurrent : css.item}
                style={images.length > 1 ? {
                    transform: `translateX(${translateX}%)`,
                    transitionDuration: `${duration}ms`,
                    transitionTimingFunction: transitionFunction,
                } : null}
            >
                <img src={item} className={css.image} alt='' />
            </li>
        );
    }

    render() {
        const { visible, delay, images, showControls, touchEnabled, onClose } = this.props;
        const { viewIndex, preventDefault } = this.state;

        const touchEvents = touchEnabled && !preventDefault && images.length > 1;

        return (
            <CSSTransition
                in={visible}
                timeout={delay}
                unmountOnExit
                classNames={{
                    enter: css.enterStart,
                    enterActive: css.enterEnd,
                    exit: css.exitStart,
                    exitActive: css.exitEnd,
                }}
                onExit={this.props.onExit}
            >
                <div className={css.root}>
                    <span className={css.overlay} onClick={onClose} />
                    <div className={css.header}>
                        <span className={css.close} onClick={onClose}>
                            <Icon className={css.closeIcon} glyph={BackIconSvg} />
                        </span>
                        {images.length > 1 && (
                            <span className={css.info}>
                                {`${viewIndex + 1} из ${images.length}`}
                            </span>
                        )}
                    </div>
                    <div className={css.body}>
                        <div
                            className={css.gallery}
                            onTouchStart={touchEvents ? (e) => this.handleTouchStart(e) : null}
                            onTouchMove={touchEvents ? (e) => this.handleTouchMove(e) : null}
                            onTouchEnd={touchEvents ? (e) => this.handleTouchEnd(e) : null}
                        >
                            {showControls && images.length > 1 && (
                                <React.Fragment>
                                    <span
                                        className={css.prev}
                                        onClick={!preventDefault ? () => this.onChangeItem(viewIndex - 1) : null}
                                    >
                                        <Icon className={css.arrowIcon} glyph={PreviewIconSvg} />
                                    </span>
                                    <span
                                        className={css.next}
                                        onClick={!preventDefault ? () => this.onChangeItem(viewIndex + 1) : null}
                                    >
                                        <Icon className={css.arrowIcon} glyph={NextIconSvg} />
                                    </span>
                                </React.Fragment>
                            )}
                            <ul className={css.galleryList}>
                                {images.map((item, index) => this.renderItem(item, index))}
                            </ul>
                        </div>
                    </div>
                </div>
            </CSSTransition>
        );
    }
}

LightboxGallery.propTypes = {
    visible: PropTypes.bool,
    delay: PropTypes.number,
    images: PropTypes.array.isRequired,
    showControls: PropTypes.bool,
    touchEnabled: PropTypes.bool,
    swipeDistance: PropTypes.number,
    duration: PropTypes.number,
    transitionFunction: PropTypes.string,
    onClose: PropTypes.func,
    onExit: PropTypes.func,
};

LightboxGallery.defaultProps = {
    visible: false,
    delay: 200,
    showControls: true,
    touchEnabled: true,
    swipeDistance: 50,
    duration: 1000, // time of animation
    transitionFunction: 'ease-in-out',
};
